<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3pTC6m/tc-custom/9780802193230.jpg?1728726267621" alt="This image is the cover for the book Up Through the Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Up Through the Water
      </h1>
      <p class="bookDescription body article font2">
        <b>New York Times Notable Book: A single mother is torn between two men in this “beautifully written” novel set on North Carolina’s Ocracoke Island (<i>The New York Times</i>)</b>.<br/><br/>Set on an island resort town in North Carolina, <i>Up Through the Water</i> tells of summer people and islanders, mothers and sons, women and men, love and its dangers. It is the story of Emily, a woman as free as the waves she swims in every day off Ocracoke Island, of the man who wants to clip her wings, of her son and the summer that he will become a man. From the author of <i>Sister Golden Hair</i> and other acclaimed works, this is a novel filled with “vigorous characters we cannot help but care about, doing interesting things in a place that is vivid and distinctive” (<i>Fort Lauderdale Sun-Sentinel</i>).<br/><br/>“The sensuous lure of summer—from primal, enveloping ocean water to the warm touch of the sun—is vividly evoked in this first novel.”—<i>Los Angeles Times Book Review</i><br/><br/>“The book can be read in a couple of hours, but it lingers like memories.”—<i>Virginian-Pilot and Ledger-Star</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darcey Steinke
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9d18003e